var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "16px",
    height: "16.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.6 972.8c230.4 0 435.2-204.8 435.2-435.2C972.8 266.24 773.12 51.2 537.6 51.2 256 51.2 51.2 256 51.2 537.6c0 235.52 215.04 435.2 486.4 435.2z m0 51.2C235.52 1024 0 803.84 0 537.6 0 230.4 230.4 0 537.6 0 803.84 0 1024 235.52 1024 537.6c0 256-230.4 486.4-486.4 486.4z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.32 348.16C35.84 399.36 25.6 455.68 25.6 512s10.24 112.64 30.72 163.84H972.8c20.48-51.2 30.72-107.52 30.72-163.84s-10.24-112.64-30.72-163.84H56.32z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.32 348.16H972.8C906.24 158.72 727.04 25.6 517.12 25.6s-394.24 133.12-460.8 322.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M967.68 675.84H56.32c66.56 189.44 245.76 322.56 455.68 322.56s389.12-133.12 455.68-322.56z",
    fill: "#FFC400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.6a41c154acbda19736dd51417c6938d6.svg";
export { ForwardRef as ReactComponent };